import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Home  from './layouts/Home';

const Routes = ({keycloak}: any) => {
  return (<BrowserRouter>
    <Switch>
      <Route exact={true} path='/*'>
        <Home keycloak={keycloak} />
      </Route>
    </Switch>
  </BrowserRouter>
  )};

export default Routes;
